import React, { Component } from 'react';
import CN from 'classnames';
import { Collapse, Tag, Button } from 'antd';
import moment from 'moment';

const Panel = Collapse.Panel;

import './NonPsychicReports.css';

const reportStatuses = {
  reportEmailSendingError: -3,
  reportDownloadError: -2,
  reportGenerationError: -1,
  pending: 0,
  generated: 1,
  downloaded: 2,
  sent: 3
};

export default class NonPsychicReports extends Component {

  static propTypes = {
    nonPsychic: React.PropTypes.object
  };

  state = {
    nonPsychic: this.props.nonPsychic
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  render() {
    const nonPsychic = this.props.nonPsychic;

    return (
      <div className="non-psychic-row">
        <div>
          <div className="non-psychic-info">
            <div>
              name: {nonPsychic.user.name}
            </div>
            <div style={{ marginBottom: 10 }}>
              email: {nonPsychic.user.email}
            </div>
            <div>
              Reports: <Tag color="red">{nonPsychic.data.length}</Tag>
            </div>
          </div>
          <Collapse>
            {nonPsychic.data.map(report => (
              <Panel
                header={moment(report.createdAt).format('YYYY-MM-DD HH:mm') + ' ' + report.reportName}
                key={report.uuid}
                className={CN({
                  'errored-report': report.status < reportStatuses.pending,
                  'pending-report': report.status === reportStatuses.pending,
                  'generated-downloaded-report': report.status === reportStatuses.generated || report.status === reportStatuses.downloaded,
                  'sent-report': report.status === reportStatuses.sent
                })}
              >
                {(report.status === reportStatuses.sent) &&
                <Button href={report.path} target="_blank" htmlType="button">Download report</Button>
                }
                <div>
                  <span className="bold">INPUT: </span>
                  <span>{Object.keys(report.reportData).reduce((acc, key) => {
                    if (key === 'item' || key === 'reportTypeUuid' || key === 'transaction' || key === 'reportType') {
                      return acc;
                    }
                    return [...acc, `${key}: ${report.reportData[key]}`];
                  }, []).join(', ')}</span>
                </div>
                <hr/>
                <div>
                  <span className="bold">REPORT: </span>
                  <span>{report.reportData.reportType}</span>
                </div>
                <div>
                  <span className="bold">STATUS: </span>
                  <span>{report.statusVerbose} ({report.status})</span>
                </div>
                <div>
                  <span className="bold">REPORT PRICE: </span>
                  <span>{report.reportInfo.price}</span>
                </div>
                <div>
                  <span className="bold">REPORT RECEIPT: </span>
                  <span>{report.webServiceOrderID}</span>
                </div>
                <div>
                  <span className="bold">IN-APP: </span>
                  <span>{report.reportInfo.storeId}</span>
                </div>
                <div>
                  <span className="bold">APP STORE RECEIPT: </span>
                  <span>{report.reportInfo.transaction}</span>
                </div>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/non-psychic-reports/NonPsychicReports.jsx